/* Hero (artist posters) — mobile dot pager. Ported from Hero.tsx's deferred
 * dot layer. Builds one dot per poster, highlights the one nearest the scroll
 * position, and scrolls to a poster on click. Dots are CSS-hidden on desktop
 * (posters sit in a row there). Handles multiple heroes; no-op with < 2 posters.
 */
(function () {
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var dotsWrap = hero.querySelector('[data-hero-dots]');
    if (!track || !dotsWrap) return;
    var posters = Array.prototype.slice.call(track.children);
    if (posters.length < 2) return;

    posters.forEach(function (poster, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero-artists__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () {
        var delta = posters[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var tl = track.getBoundingClientRect().left;
        var idx = 0, best = Infinity;
        posters.forEach(function (p, i) {
          var d = Math.abs(p.getBoundingClientRect().left - tl);
          if (d < best) { best = d; idx = i; }
        });
        // Last poster is never "nearest left" at max scroll — force it active.
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) idx = posters.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    });

    // Auto-advance the mobile carousel every 6s; pause on hover / touch. On the
    // desktop grid the track isn't scrollable, so scrollTo is a no-op there.
    var paused = false;
    hero.addEventListener('pointerenter', function () { paused = true; });
    hero.addEventListener('pointerleave', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    setInterval(function () {
      if (paused || track.scrollWidth <= track.clientWidth + 2) return;
      var tl = track.getBoundingClientRect().left, cur = 0, best = Infinity;
      posters.forEach(function (p, i) { var d = Math.abs(p.getBoundingClientRect().left - tl); if (d < best) { best = d; cur = i; } });
      var nextI = (cur + 1) % posters.length;
      var delta = posters[nextI].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
    }, 6000);
  });
})();
